import createReducer from 'redux/lib/reducerConfig';

const initialState = {
  data: [],
};

const ActionTypes = {
  SET_COMPANY_JOBS: 'COMPANY_JOBS/SET_COMPANY_JOBS',
};

export function setCompanyJobs(companyJobs) {
  return {
    type: ActionTypes.SET_COMPANY_JOBS,
    payload: companyJobs,
  };
}

export const jobsReducer = createReducer(
  initialState,
  {
    [ActionTypes.SET_COMPANY_JOBS]: (state, action) => {
      return {
        ...state,
        data: action.payload,
      };
    },
  }
);
